import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  gridSizeMdLg12,
  gridSizeMdLg4,
  gridSizeMdLg6,
  gridSizeMdLg8,
  LocalidadENUM,
  nodosSchema,
  texto,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomNumberTextField,
  CustomTextField,
  CustomTextFieldNoForm,
  CustomTextFieldNumberComponente,
  SampleDatePicker,
  SingleFormBoxScene,
  SwitchComponenteForm,
  TabTextLabel,
} from "@/shared/components/ui";
// import {
//   OLT
// } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { getBodegas, getUbicaciones, useCreateNodo, useUpdateNodo } from "@/shared/actions/erp";
import {
  Grid,
} from "@mui/material";
import { Nodo, Zone } from "@/shared/interfaces/erp/mantenimiento-operaciones";
import { useLocalidad } from "@/shared/hooks/useLocalidad";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import dayjs from "dayjs";
import CustomAutocompleteMultipleArrString from "@/shared/components/ui/CustomAutocompleteMultipleArrString";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";


const returnUrlNodo = "/mantenimiento-operaciones/nodos";

export interface SaveNodoProps {
  titlePage: string;
  editNodo?: Nodo;
  enableUploadFile?: boolean;
}
type SaveFormData = {
  olt?: string
  nombre: string
  direccion: string
  zona?: string
  coordenadas: string
  estado?: boolean

  contacto_principal?: string
  numero_contacto_principal?: string
  contacto_secundario?: string
  numero_contacto_secundario?: string
  numero_contrato_luz?: string
  numero_medidor_luz?: string
  tipo_servicio_luz?: string[] | string | null
  duracion_contrato_luz?: string | null
  restante_contrato_luz?: number
  fecha_inicio_contrato_luz?: string | null
  ubicacion?: string | null
  // nombre: string;
  // direccion: string;
  // coordenadas: string;
  // estado: boolean;
  // pais: string;
  // provincia: string;
  // ciudad: string;
  // zona: string;
  // sector: string;
  // cantidad?: number;
  // serie?: string;
  // es_bras: boolean
  // bras?: string
  // olt?:string

};
const saveNodo: React.FC<SaveNodoProps> = ({ titlePage, editNodo }) => {
  const navigate = useNavigate();

  //*local state
  const [shrink, setShrink] = useState(false);



  ///* global state

  const setAlert = useUiStore((s) => s.setAlert);
  const fechaInicioMasDuracion = editNodo?.duracion_contrato_luz
    && editNodo?.fecha_inicio_contrato_luz ?
    dayjs(editNodo?.fecha_inicio_contrato_luz).add(editNodo?.duracion_contrato_luz, "year") : null;
  ///* fetch data
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(nodosSchema),
    defaultValues: {
      coordenadas: '0,0',
      restante_contrato_luz: fechaInicioMasDuracion ? fechaInicioMasDuracion.diff(dayjs(), "month") : 0,
      tipo_servicio_luz: editNodo && (editNodo?.tipo_servicio_luz as string[] | string)?.length > 0 ? (editNodo.tipo_servicio_luz as string)?.split(",") : null,
      fecha_inicio_contrato_luz: editNodo?.fecha_inicio_contrato_luz || null,
      duracion_contrato_luz: editNodo?.duracion_contrato_luz?.toString() || null,
      // es_bras: false
    }
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;



  const {
    // dataPais,
    // isLoadingPais,
    // dataProvincia,
    // isLoadingProvincia,
    // dataCiudad,
    // isLoadingCiudad,
    dataZona,
    isLoadingZona,
    // dataSector,
    // isLoadingSector,
    handleReset
  } = useLocalidad({
    form: form as any,
    withoutControl: true
  })


  ///* mutations
  const createNodo = useCreateNodo({ navigate, returnUrl: returnUrlNodo });
  const updateNodo = useUpdateNodo({ navigate, returnUrl: returnUrlNodo });

  // const {
  //   data: allOlts,
  //   isLoading: isLoadingolts,
  //   isRefetching: isRefetchingolts,
  // } = useFetchOLTs({
  //   enabled: true, ///* zona
  //   params: {
  //     page_size: 1000,
  //   },
  // });

  ///* handlers
  const onSave = (dataForm: SaveFormData) => {

    if (!isValid) return;

    let newData = dataForm
    const aux_tipo_servicio_luz = (dataForm?.tipo_servicio_luz 
      && typeof(dataForm?.tipo_servicio_luz)=="string" && !dataForm?.tipo_servicio_luz?.includes("[")?
      dataForm?.tipo_servicio_luz
      :dataForm?.tipo_servicio_luz?.includes("[")?
      JSON.parse(dataForm?.tipo_servicio_luz as string).join(",")
      :null
    )
    if (dataForm?.tipo_servicio_luz
      && dataForm?.tipo_servicio_luz?.length > 0) {
      newData = {
        ...dataForm,
        tipo_servicio_luz: aux_tipo_servicio_luz
      }
    }

    if (editNodo?.id_nodo) {
      ///* upd
      return updateNodo.mutate({
        id: editNodo.id_nodo,
        data: {
          ...(newData as any),
        },
      });
    }

    ///* create
    return createNodo.mutate({
      ...(newData as any),
    });
  };

  const duracionContratoLuz = form.watch().duracion_contrato_luz;
  const fechaInicioContratoLuz = form.watch().fecha_inicio_contrato_luz;
  const calculateRemainingTime = (duracion: number, fechaInicio: string) => {
    const fechaFin = dayjs(fechaInicio).add(duracion, "year");
    const remainingTime = fechaFin.diff(dayjs(), "month");
    return remainingTime > 0 ? remainingTime : 0;
  };


  ///* effects


  useEffect(() => {
    if (editNodo) {
      setShrink(true);
      reset({
        ...editNodo,
        es_bras: !!editNodo.bras
      } as any);
    }
  }, [editNodo]);



  const [bodega_origen, setBodegaOrigen] = useState('');

  ///* store, hook
  const {
    fetchAutocompleteUbicacion,
    fetchAutocompleteBodega
  } = useAutocompleteFetch();


  const ubicacionOrigenParams = useMemo(() => ({
    bodega: bodega_origen
  }), [bodega_origen])

  return (
    <SingleFormBoxScene
      titlePage={titlePage || 'Nodo'}
      onCancel={() => {
        navigate(returnUrlNodo);
      }}
      onSave={handleSubmit(onSave, () => {
        setAlert(true, "Faltan campos por llenar", "error");
      })}

    >
      <Grid container spacing={3} py={3}>

        {/* <CustomAutocomplete<OLT>
          label="OLT"
          name="olt"
          //// options
          options={allOlts?.data?.data || []}
          // label & id as fk
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().olt || ''}
          isLoadingData={isLoadingolts || isRefetchingolts}
          //// validation
          control={form.control}
          error={errors.olt}
          helperText={errors.olt?.message}
          size={gridSizeMdLg6}
        /> */}

        <CustomTextField
          name="nombre"
          label="Nombre"
          control={form.control}
          defaultValue={form.getValues().nombre || ""}
          error={errors.nombre}
          helperText={errors.nombre?.message}
          shrink={shrink}
          size={gridSizeMdLg12}
        />
        <CustomTextField
          name="direccion"
          label="Direccion"
          control={form.control}
          defaultValue={form.getValues().direccion || ""}
          error={errors.direccion}
          helperText={errors.direccion?.message}
          shrink={shrink}
          size={gridSizeMdLg12}
        />
        <CustomAutocomplete<Zone>
          label="Zona"
          name="zona"
          required={false}
          actualValueKey="codigo"
          //// options
          options={dataZona?.data.data || []}
          // label & search by name
          valueKey="nombre"
          //
          defaultValue={form.getValues().zona || ""}
          optionLabelForEdit={form.getValues().zona || ""}
          isLoadingData={isLoadingZona}
          //// validation
          control={control}
          error={errors.zona}
          helperText={errors.zona?.message}
          onChangeValue={(e) => {
            handleReset(LocalidadENUM.ZONA)
            reset({
              ...form.getValues(),
              zona: e
            })
          }}
          size={gridSizeMdLg12}
        />

        <CustomCoordendasForm
          form={form}
          label="Coordendas"
          name="coordenadas"
          defaultValue={form.watch().coordenadas}
          key={'key_nodo_coordenadas'}
          size={gridSizeMdLg8}
          onlyValueLocation={true}
          enableLocationOnChange={false}
        />

        <SwitchComponenteForm
          label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
          size={gridSizeMdLg4}
          control={form.control}
          defaultValue={!!form.getValues()?.estado}
          name="estado"
        />

        <CustomTextField
          name="contacto_principal"
          label="Contacto Principal"
          control={form.control}
          defaultValue={form.getValues().contacto_principal || ""}
          error={errors.contacto_principal}
          helperText={errors.contacto_principal?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
        />
        <CustomTextFieldNumberComponente
          size={gridSizeMdLg6}
          type={TiposTextFieldNumberEnum.CELULAR}
          label={"Número de contacto principal"}
          error={errors.numero_contacto_principal}
          helperText={errors.numero_contacto_principal?.message}
          control={control}
          name="numero_contacto_principal"
          defaultValue={form.getValues().numero_contacto_principal || ''}
          required={false}
        />

        <CustomTextField
          name="contacto_secundario"
          label="Contacto Secundario"
          control={form.control}
          defaultValue={form.getValues().contacto_secundario || ""}
          error={errors.contacto_secundario}
          helperText={errors.contacto_secundario?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
        />
        <CustomTextFieldNumberComponente
          size={gridSizeMdLg6}
          required={false}
          type={TiposTextFieldNumberEnum.CELULAR}
          label={"Número de contacto secundario"}
          error={errors.numero_contacto_secundario}
          helperText={errors.numero_contacto_secundario?.message}
          control={control}
          name="numero_contacto_secundario"
          defaultValue={form.getValues().numero_contacto_secundario || ''}
        />
        <TabTextLabel text="Datos de Servicio Eléctrico" />
        <CustomTextField
          name="numero_contrato_luz"
          label="Número de contrato de luz"
          control={form.control}
          defaultValue={form.getValues().numero_contrato_luz || ""}
          error={errors.numero_contrato_luz}
          helperText={errors.numero_contrato_luz?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
        />
        <CustomTextField
          name="numero_medidor_luz"
          label="Número de medidor de luz"
          control={form.control}
          defaultValue={form.getValues().numero_medidor_luz || ""}
          error={errors.numero_medidor_luz}
          helperText={errors.numero_medidor_luz?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
        />
        <CustomAutocompleteMultipleArrString
          label="Tipo de Respaldo"
          name="tipo_servicio_luz"
          control={form.control}
          textFieldKey="tipo_servicio_luz"
          error={!!errors.tipo_servicio_luz}
          isLoadingData={false}
          helperText={errors.tipo_servicio_luz?.message}
          defaultValue={
            (form.getValues()?.tipo_servicio_luz?.length || 0) > 0 ?
              (form.getValues()?.tipo_servicio_luz?.toString() || "")?.split(",") : []
          }
          options={["UPS", "GENERADOR", "PANELES SOLARES"]}
          size={gridSizeMdLg6}
          required={false}
        />
        <SampleDatePicker
          name="fecha_inicio_contrato_luz"
          label="Fecha de inicio del contrato"
          control={form.control}
          defaultValue={form.getValues().fecha_inicio_contrato_luz || ""}
          error={errors.fecha_inicio_contrato_luz}
          helperText={errors.fecha_inicio_contrato_luz?.message}
          // shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
        />
        <CustomNumberTextField
          name="duracion_contrato_luz"
          label="Duración del contrato"
          control={form.control}
          defaultValue={form.getValues().duracion_contrato_luz || ""}
          error={errors.duracion_contrato_luz}
          helperText={errors.duracion_contrato_luz?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
          onlyInteger={true}
          endAdornment="Año/s"
        />
        <CustomTextFieldNoForm
          label="Tiempo restante del contrato"
          value={
            duracionContratoLuz && fechaInicioContratoLuz
              ? calculateRemainingTime(parseInt(duracionContratoLuz || "0"), fechaInicioContratoLuz)
              : "N/D"
          }
          shrink={shrink}
          size={gridSizeMdLg6}
          required={false}
          disabled={true}
          endAdornment="Mes/es"
        />


        <CustomAutocompleteFetchForm<BODEGAS, any, string>
          control={control}
          size={gridSizeMdLg6}
          name="bodega_origen"
          //isAll
          label={texto.bodega}
          fetchData={fetchAutocompleteBodega}
          getOptionLabel={(opt) => opt.nombre || ''}
          key={'autocomplete-bodega-origen'}
          getOptionKey={(o) => o.codigo!}
          onChangeRawValue={(e) => {
            reset({
              ...form.getValues(),
              ubicacion: null,
            });
            if (e) {
              setBodegaOrigen(e.codigo)
            }
          }}
          loadOptionByValue={async (cod) => {
            const resp = await getBodegas({
              codigo: cod
            });
            return resp.data.data[0] ?? null
          }}
        />


        <CustomAutocompleteFetchForm<Ubicaciones>
          disabled={!bodega_origen}
          control={control}
          size={gridSizeMdLg6}
          name="ubicacion"
          label="Ubicación Origen"
          ///* fetch
          fetchData={fetchAutocompleteUbicacion}
          fetchParams={ubicacionOrigenParams}
          loadOptionByValue={async (codigo) => {
            const res = await getUbicaciones({
              codigo: codigo as string
            });
            return res?.data.data[0] ?? null;
          }}
          getOptionLabel={(opt) => opt.nombre || ''}
          key={'autocomplete-ubicacion-origen'}
          getOptionKey={(o) => o.codigo!}
          onChangeValue={() => {
            // reset({ ...form.getValues(), ubicacion: e.codigo });
          }}
        />


      </Grid>
    </SingleFormBoxScene>
  );
};

export default saveNodo;
